import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { CheckboxFormField } from "../common/components/FormFields";

export interface OtlConsentProps {}

export const OtlConsent: React.FC<OtlConsentProps> = ({}) => {
  return (
    <Stack gap={2}>
      <Box>
        <Typography variant="h6" paragraph>
          PRIVACY POLICY CONSENT
        </Typography>
        <Typography paragraph>
          By submitting this form, you consent to the use, collection and
          disclosure of your personal information for the purpose of verifying
          your eligibility for on-the-land support, in accordance with our{" "}
          <a href={"https://irc.inuvialuit.com/privacy-policy/"}>
            Privacy Policy
          </a>
          . To process your application, you consent to IRC sharing this
          information with your applicable Community Corporation. Your
          information will not be shared with another third party without your
          consent, unless required by law.
        </Typography>
        <CheckboxFormField
          name="releaseAccept"
          mustBeTrue
          label={
            <span>
              I have read and agree to the collection, use and disclosure of my
              personal information as described above and in the{" "}
              <a
                href={"https://irc.inuvialuit.com/privacy-policy/"}
                target={"_blank"}
                rel="noreferrer"
              >
                Privacy Policy
              </a>
              . *
            </span>
          }
        />
      </Box>
    </Stack>
  );
};
